import {
  GetProviderOrgDetailsActionTypes,
  GET_PROVIDER_ORG_DETAILS_FAIL,
  GET_PROVIDER_ORG_DETAILS_LOADING,
  GET_PROVIDER_ORG_DETAILS_SUCCESS,
  GetProviderOrgDetailsState,
  GET_PROVIDER_ORG_DETAILS_API_MSG,
  GET_PROVIDER_ORG_DETAILS_API_RES,
} from "./ActionTypes";
import { GetProviderOrgDetails } from "./Model";

const initialStateGetPosts: GetProviderOrgDetailsState = {
  loading: false,
  getProviderOrgDetailsRes: {} as GetProviderOrgDetails,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getProviderOrgDetailsReducer = (
  state = initialStateGetPosts,
  action: GetProviderOrgDetailsActionTypes
): GetProviderOrgDetailsState => {
  switch (action.type) {
    case GET_PROVIDER_ORG_DETAILS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_PROVIDER_ORG_DETAILS_SUCCESS:
      return {
        ...state,
        getProviderOrgDetailsRes: action.payload,
        successMsg: action.successMsg,
      };
    case GET_PROVIDER_ORG_DETAILS_FAIL:
      return {
        ...state,
        getProviderOrgDetailsRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_PROVIDER_ORG_DETAILS_API_MSG:
      return {
        ...state,
        getProviderOrgDetailsRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_PROVIDER_ORG_DETAILS_API_RES:
      return {
        ...state,
        getProviderOrgDetailsRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
